module.exports = __webpack_public_path__ + "static/media/packshot-and-bg@3x.954ca794.png";